import { tryPromise } from "../../base/cutil/LangUtil";
import isBlank from "@sedan-utils/is-blank";
import qs from "qs";
export class LinkService {
    constructor(brainClient, meStore) {
        this.brainClient = brainClient;
        this.meStore = meStore;
    }
    structureLinkParameters(params) {
        const previewV2 = params.enablePreviewApp === true
            ? {
                type: params.type,
                appId: params.appId,
                uuid: params.uuid,
            }
            : {};
        const queryParameters = {
            stripePaymentActivated: isBlank(params.stripe_price_id) === false ? false : undefined,
            selectedUI: params.selectedUI,
            ...previewV2,
        };
        return qs.stringify(queryParameters, { skipNulls: true });
    }
    structureUrl(index, parameters) {
        const newUrl = `${window.location.origin}${window.location.pathname}#/editor`;
        const link = `${newUrl}/shared_intelligent_app/${index}?${parameters}`;
        return link;
    }
    async generateLink(params) {
        const parameters = this.structureLinkParameters(params.structureLinkParams);
        const url = this.structureUrl(params.index, parameters);
        const linkData = {
            $web_only: true,
            $fallback_url: url,
        };
        const hasConsistentShareLinkPermission = await this.meStore.hasConsistentShareLinkPermission();
        let result;
        if (hasConsistentShareLinkPermission) {
            result = await tryPromise(this.brainClient.openAi.dynamicLinkV2(linkData));
        }
        else {
            result = await tryPromise(this.brainClient.openAi.dynamicLink(linkData));
        }
        return result.data?.data?.dynamiclink || url;
    }
}
